import { animatePulse } from "@/src/utils/animation.utils";
import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

export const ProfileSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    <Animated.View
      style={{ opacity }}
      className="bg-chalk rounded-[16px] border border-ash-3 overflow-hidden"
    >
      {/* Background image */}
      <View className="h-[140px] bg-ash-3" />

      <View className="p-4 gap-3">
        {/* Avatar */}
        <View className="w-[100px] h-[100px] rounded-full bg-ash-3 -mt-16 border-4 border-white" />

        {/* Name and edit button */}
        <View className="flex-row justify-between items-center">
          <View className="h-5 w-40 bg-ash-3 rounded-md" />
          <View className="h-6 w-6 bg-ash-3 rounded-full" />
        </View>

        {/* Description */}
        <View className="h-3 w-3/4 bg-ash-3 rounded-md" />

        {/* Member since */}
        <View className="h-3 w-1/2 bg-ash-3 rounded-md" />
      </View>

      {/* Tabs skeleton */}
      <View className="px-4 py-3 border-t border-ash-3 flex-row gap-4">
        <View className="h-4 w-12 bg-ash-3 rounded-md" />
        <View className="h-4 w-12 bg-ash-3 rounded-md" />
        <View className="h-4 w-12 bg-ash-3 rounded-md" />
        <View className="h-4 w-12 bg-ash-3 rounded-md" />
      </View>
    </Animated.View>
  );
};

export const ProfileInfoSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    <Animated.View style={{ opacity }}>
      {/* Personal Details */}
      <View className="gap-4">
        <View className="h-4 w-32 bg-ash-3 rounded-md" />
        {Array.from({ length: 5 }).map((_, index) => (
          <View key={index} className="flex-row items-center gap-4">
            <View className="w-6 h-6 bg-ash-3 rounded-full" />
            <View className="gap-1 flex-1">
              <View className="h-3 w-20 bg-ash-3 rounded-md" />
              <View className="h-3 w-36 bg-ash-3 rounded-md" />
            </View>
          </View>
        ))}
      </View>

      {/* Work Details */}
      <View className="gap-4 mt-6">
        <View className="h-4 w-24 bg-ash-3 rounded-md" />
        {Array.from({ length: 4 }).map((_, index) => (
          <View key={index} className="flex-row items-center gap-4">
            <View className="w-6 h-6 bg-ash-3 rounded-full" />
            <View className="gap-1 flex-1">
              <View className="h-3 w-20 bg-ash-3 rounded-md" />
              <View className="h-3 w-36 bg-ash-3 rounded-md" />
            </View>
          </View>
        ))}
      </View>
    </Animated.View>
  );
};
